/** URL-safe base64 of an ASCII/Latin1 string: `+`→`-`, `/`→`_`, drop `=` padding. Shared so the PKCE
 *  flow and the box-truck deep-link builder don't each hand-roll the same three replaces. */
export const toBase64Url = (input: string): string => btoa(input).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
